<template>
  <div class="home">
    <!-- 非会員home -->
    <!-- <div class="hero is-primary is-halfheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-size-1-desktop is-size-3-touch">
            アートをみんなに
          </h1>
        </div>
      </div>
    </div> -->

    <!-- カルーセル -->
    <div class="slide">
      <h1 class="slide__title">アートをみんなに</h1>
      <img
        src="../assets/image/home_keyvisual.jpg"
        width="1152"
        height="450"
        alt=""
      />
      <img
        src="../assets/image/home_keyvisual_2.jpg"
        width="1152"
        height="450"
        alt=""
      />
      <img
        src="../assets/image/home_keyvisual_3.jpg"
        width="1152"
        height="450"
        alt=""
      />
    </div>

    <div class="section">
      <div class="container">
        <div
          class="columns is-justify-content-space-between is-variable is-0-tablet is-8-desktop"
        >
          <div class="column is-half">
            <h2
              class="title is-size-3-desktop is-size-4-touch has-text-primary hometitle"
            >
              Concept
            </h2>
            <p class="block">
              音楽・絵画・彫刻・ダンス・アイドル、多くのアートが世の中には溢れています。<br />
              しかしながら、アーティストを目指すには多くの時間とお金がかかります。<br />またアートを楽しむきっかけがないままに毎日を過ごす人もたくさんいます。
            </p>
            <p class="block">
              そんな不都合をなくす世界を作りたい。<br />
              アーティストになる人を応援し、アートを楽しむ人をたくさん作る。<br />こんな時代だからこそ、アートを楽しむをたくさん作りたいと思っています。
            </p>
            <p class="block">
              アートは人生を豊かにする大事な手段だと私たちは信じています。
            </p>
          </div>
          <div class="column">
            <picture class="image"
              ><img
                src="../assets/image/home_concept.jpg"
                width="675"
                height="405"
                alt=""
            /></picture>
          </div>
        </div>
      </div>
    </div>

    <div class="section pt-2">
      <div class="container">
        <div
          class="columns is-justify-content-space-between is-variable is-0-tablet is-8-desktop reverse-columns"
        >
          <div class="column is-half">
            <h2
              class="title is-size-3-desktop is-size-4-touch has-text-primary hometitle"
            >
              How to
            </h2>
            <p>
              色んなジャンルのパフォーマーがいつでも配信中。<br />プロを目指す音大生、芸大生、地下アイドルまで、多くのパフォーマーが毎日配信しています。<br />より詳しい遊び方はこちら
            </p>
            <div class="container mt-5">
              <div class="columns">
                <div class="column pandorabutton__parent">
                  <b-button
                    type="is-primary"
                    tag="a"
                    href="#"
                    class="pandorabutton pandorabutton--arowicon"
                    expanded
                    >How to</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <picture class="image">
              <img
                src="../assets/image/home_howto.jpg"
                width="675"
                height="405"
                alt=""
              />
            </picture>
          </div>
        </div>
      </div>
    </div>

    <div class="section pt-2">
      <div class="container">
        <div class="columns is-mobile">
          <h2
            class="column title is-size-3-desktop is-size-4-touch has-text-primary mb-0 hometitle"
          >
            News
          </h2>
          <p class="column has-text-right">
            <a href="#" class="morelink">もっと見る</a>
          </p>
        </div>
        <dl class="news">
          <dt class="news__dt">2021.2.9</dt>
          <dd class="news__dd">
            <a href="#"
              >ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。</a
            >
          </dd>
          <dt class="news__dt">2021.1.31</dt>
          <dd class="news__dd">
            <a href="#"
              >ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。ニュースてきすとが入ります。</a
            >
          </dd>
        </dl>
      </div>
    </div>
    <!-- //非会員home -->

    <!-- 会員home -->
    <div class="section section--livestreaming">
      <div class="container">
        <div class="columns">
          <h1 class="column subtitle is-size-5-desktop is-size-6-touch mb-0">
            配信中
          </h1>
          <div class="column is-hidden-touch"></div>
        </div>
        <ul class="columns is-multiline is-mobile">
          <LiveListedTile
            v-for="live in recentLives"
            :key="live.id"
            :tileData="{
              liveId: live.id,
              imageSrc: live.thumbnailUrl,
              nickname: performerName(live.userId),
              genre: category(live.userId)
            }"
            :onClick="liveTileClicked"
          />
        </ul>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="columns">
          <h1 class="column subtitle is-size-5-desktop is-size-6-touch mb-0">
            配信予定
          </h1>
          <div class="column has-text-right is-hidden-touch">
            <a href="#" class="morelink">もっと見る</a>
          </div>
        </div>
        <ul class="columns is-multiline is-mobile">
          <LiveListedTile
            v-for="live in upComingLives"
            :key="live.id"
            :tileData="{
              liveId: live.id,
              imageSrc: live.thumbnailUrl,
              nickname: performerName(live.userId),
              genre: category(live.userId)
            }"
            :onClick="liveTileClicked"
          />
        </ul>
        <div class="columns is-hidden-desktop is-mobile">
          <div class="column pandorabutton__parent">
            <b-button
              type="is-primary"
              tag="a"
              href="#"
              class="pandorabutton pandorabutton--arowicon"
              expanded
              >もっと見る</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="section pt-0">
      <div class="container">
        <div class="columns">
          <h1 class="column subtitle is-size-5-desktop is-size-6-touch mb-0">
            ランキング
          </h1>
          <div class="column has-text-right is-hidden-touch">
            <a href="#" class="morelink">もっと見る</a>
          </div>
        </div>
        <ul class="columns is-multiline is-mobile">
          <li
            class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
          >
            <a href="#">
              <div class="thumbnail">
                <span class="ranklabel ranklabel--rank1">1位</span>
                <img src="http://placehold.jp/400x255.png" />
              </div>
              <p class="is-size-6">なまえ名前なまえ名前</p>
            </a>
          </li>
          <li
            class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
          >
            <a href="#">
              <div class="thumbnail">
                <span class="ranklabel ranklabel--rank2">2位</span>
                <img src="http://placehold.jp/400x255.png" />
              </div>
              <p class="is-size-6">なまえ名前なまえ名前</p>
            </a>
          </li>
          <li
            class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
          >
            <a href="#">
              <div class="thumbnail">
                <span class="ranklabel ranklabel--rank3">3位</span>
                <img src="http://placehold.jp/400x255.png" />
              </div>
              <p class="is-size-6">なまえ名前なまえ名前</p>
            </a>
          </li>
          <li
            class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
          >
            <a href="#">
              <div class="thumbnail">
                <span class="ranklabel ranklabel--rank4">4位</span>
                <img src="http://placehold.jp/400x255.png" />
              </div>
              <p class="is-size-6">なまえ名前なまえ名前</p>
            </a>
          </li>
        </ul>
        <div class="columns is-hidden-desktop is-mobile">
          <div class="column pandorabutton__parent">
            <b-button
              type="is-primary"
              tag="a"
              href="#"
              class="pandorabutton pandorabutton--arowicon"
              expanded
              >もっと見る</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- //会員home -->
  </div>
</template>

<script>
import LiveListedTile from '@/components/Molecules/LiveListedTile';
import { mapState } from 'vuex';
import { getPerformerDocByUserId } from '@/services/performerServices';
import * as authServices from '@/services/authServices';

// タイルの同時表示数
const tilesNumber = 8;

export default {
  name: 'Home',
  components: {
    LiveListedTile
  },
  data() {
    return {
      performers: null
    };
  },
  async created() {
    if (
      !authServices.getFirebaseUser().emailVerified &&
      !this.$route.path.includes('signup')
    ) {
      this.$router.push('/user/created');
    }

    await this.$store.dispatch('live/loadRecentLives');
    await this.$store.dispatch('live/loadUpComingAllLives');

    const userIds = Array.from(
      new Set(this.$store.state.live.upComingAllLives.map(e => e.userId))
    );
    this.performers = await Promise.all(
      userIds.map(async userId => {
        return await getPerformerDocByUserId(userId);
      })
    );
  },
  computed: {
    ...mapState({
      recentLives: state => state.live.recentLives.slice(0, tilesNumber),
      upComingLives: state => state.live.upComingAllLives.slice(0, tilesNumber)
    }),
    category() {
      const self = this;
      return function (id) {
        const defaultCategory = 'カテゴリ無し';
        if (!self.performers) {
          return defaultCategory;
        }
        const performer = self.performers.find(p => p?.id === id);
        if (!performer) {
          return defaultCategory;
        }
        return performer.category;
      };
    },
    performerName() {
      const self = this;
      return function (id) {
        const defaultPerformerName = '名無しさん';
        if (!self.performers) {
          return defaultPerformerName;
        }
        const performer = self.performers.find(p => p?.id === id);
        if (!performer) {
          return defaultPerformerName;
        }
        return performer.performerName;
      };
    }
  },
  methods: {
    liveTileClicked(id) {
      this.$router.push(`/live/streaming/${id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/home.scss';
</style>
